import React from 'react';
import { Navigate } from 'react-router-dom';
import { LoginButton } from '@components';
import { useAppCookies } from '@app/providers/AppCookieProvider';

interface HomeProps {
  children?: any;
}

export const Home: React.FC<HomeProps> = () => {
  const { auth } = useAppCookies();

  return auth.available ? <Navigate to="/groups" /> : <LoginButton loginButtonHelp="Sign in with Google" />;
};
